import { motion } from "framer-motion";
import { HandCoins, HeartHandshake, Hand, ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n";

const ICONS = { donate: HandCoins, adopt: HeartHandshake, volunteer: Hand };
const EASE = [0.16, 1, 0.3, 1];

export default function CosaPuoiFare({ onDonate, scrollTo }) {
  const { t } = useLang();

  const handle = (key) => {
    if (key === "donate") onDonate();
    else if (key === "adopt") {
      window.location.href = "/adozione-a-distanza";
    } else if (key === "volunteer") {
      window.location.href = "/volontariato";
    } else scrollTo("contatti");
  };

  return (
    <section id="cosa-puoi-fare" data-testid="cosa-puoi-fare-section" className="py-28 md:py-36">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
          className="text-[12px] font-semibold uppercase tracking-[0.35em] text-primary"
        >
          {t.help.label}
        </motion.p>
        <div className="mt-5 flex flex-wrap items-end justify-between gap-6">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
            className="max-w-xl font-serif text-4xl leading-[1.05] tracking-tight text-white md:text-5xl"
          >
            {t.help.title}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.2, ease: EASE }}
            className="max-w-sm text-base text-white/60"
          >
            {t.help.sub}
          </motion.p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {t.help.cards.map((c, i) => {
            const Icon = ICONS[c.key];
            return (
              <motion.div
                key={c.key}
                data-testid={`help-card-${c.key}`}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.85, delay: i * 0.12, ease: EASE }}
                className="group flex flex-col rounded-3xl border border-white/10 bg-white/[0.04] p-10 transition-all duration-500 hover:-translate-y-2 hover:border-primary/50 hover:bg-white/[0.07]"
              >
                <span className="grid h-14 w-14 place-items-center rounded-2xl bg-primary/15 text-primary transition-colors duration-500 group-hover:bg-primary group-hover:text-white">
                  <Icon size={26} strokeWidth={1.8} />
                </span>
                <h3 className="mt-8 font-serif text-3xl tracking-tight text-white">{c.title}</h3>
                <p className="mt-4 flex-1 text-base leading-relaxed text-white/65">{c.text}</p>
                <button
                  data-testid={`help-${c.key}-button`}
                  onClick={() => handle(c.key)}
                  className="mt-8 flex items-center gap-2 text-[13px] font-semibold uppercase tracking-[0.14em] text-primary transition-colors duration-300 hover:text-white"
                >
                  {c.cta}
                  <ArrowUpRight
                    size={16}
                    className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                  />
                </button>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
